import React, { Component } from 'react'
import PropTypes from 'prop-types'

import componentMapper from './componentMapper'

export default class Typestack extends Component {
  static propTypes = {
    align: PropTypes.oneOf(['inherit', 'left', 'center', 'right', 'justify']),
    children: PropTypes.node,
    size: PropTypes.oneOf(['xl', 'lg', 'md', 'sm', 'xs']),
    type: PropTypes.oneOf(['highlight', 'heading', 'paragraph', 'eyebrow'])
  }

  static defaultProps = {
    align: 'inherit'
  }

  render() {
    const {
      children,
      className,
      size,
      type,
      ...rest
    } = this.props

    const { componentProp, Component } = componentMapper({ type, size })

    return (
      <Component
        className={className}
        componentProp={componentProp}
        type={type}
        size={size}
        {...rest}
      >
        {children}
      </Component>
    )
  }
}
